import React, { useState, useEffect } from "react";
import { Button, Select, Switch } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";
import HarvestFilterWrapper from "./HarvestFilterModal.styles";
import { Checkbox } from "antd";

const CheckboxGroup = Checkbox.Group;

const HarvestFilterModal = (props) => {
  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(
    props.selectedBlocks ? props.selectedBlocks : []
  );
  const [notSelectedOptions, setNotSelectedOptions] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(true); // 1. State to track "All" checkbox
  const cancelModal = () => {
    props.cancelBlockFilterModal();
  };

  useEffect(() => {
    const options = [];
    const defaultValue = [];
    if (props.harvest) {
      props.harvest.forEach((type) => {
        options.push({
          value: type.id,
          label: type.name,
        });
        defaultValue.push(type.id); // Always push to defaultValue
      });
    }
    setSelectedOptions(defaultValue);
    setTypeOptions(options);
  }, [props.harvest]);

  useEffect(() => {
    const notSelected = [];
    typeOptions.forEach((option) => {
      if (!selectedOptions.includes(option.value)) {
        notSelected.push(option.value);
      }
    });
    setNotSelectedOptions(notSelected);
  }, [selectedOptions]);

  const handleChangeType = (list) => {
    setSelectedOptions(list);
  };

  const handleSelectAll = (e) => { // 2. Function to handle "All" checkbox change
    const checked = e.target.checked;
    setSelectAllChecked(checked);
    const allOptions = typeOptions.map((option) => option.value);
    setSelectedOptions(checked ? allOptions : []);
  };

  const handleSubmit = () => {
    props.handleFilterBlock &&
      props.handleFilterBlock({
        selectedTypeIds: selectedOptions,
        notSelectedTypeIds: notSelectedOptions,
      });
    cancelModal();
  };

  return (
    <HarvestFilterWrapper
      forceRender={true}
      visible={props.visibleBlockFilter}
      title={<IntlMessages id="Block Filter" />}
      onCancel={cancelModal}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button
          key="submit"
          className="btn-success"
          type="primary"
          onClick={handleSubmit}
        >
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
      <div className="option-container">
        <label className="title">Select Block</label>
        <div>
          <Checkbox onChange={handleSelectAll} checked={selectAllChecked}>All</Checkbox> {/* 3. Check the "All" checkbox based on selectAllChecked state */}
        </div>
        <CheckboxGroup
          options={typeOptions}
          value={selectedOptions}
          onChange={handleChangeType}
        />
      </div>
      <div className="option-container">
        <label className="title">Show Block label</label>
        <Switch
          checkedChildren="Show"
          unCheckedChildren="Hide"
          checked={props.isShowBlockLabel}
          onChange={(value) => props.setIsShowBlockLabel(value)}
        />
      </div>
    </HarvestFilterWrapper>
  );
};

export default HarvestFilterModal;
